var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVault(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20726_7610)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.75 17.5C3.41667 17.5 3.125 17.375 2.875 17.125C2.625 16.875 2.5 16.5833 2.5 16.25V3.75C2.5 3.41667 2.625 3.125 2.875 2.875C3.125 2.625 3.41667 2.5 3.75 2.5H16.25C16.5833 2.5 16.875 2.625 17.125 2.875C17.375 3.125 17.5 3.41667 17.5 3.75V16.25C17.5 16.5833 17.375 16.875 17.125 17.125C16.875 17.375 16.5833 17.5 16.25 17.5H3.75ZM3.75 16.25H16.25V3.75H3.75V16.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.084 10.625C13.1195 10.625 13.959 9.78553 13.959 8.75C13.959 7.71447 13.1195 6.875 12.084 6.875C11.0485 6.875 10.209 7.71447 10.209 8.75C10.209 9.78553 11.0485 10.625 12.084 10.625Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.584 12.5C14.584 12.8452 14.3042 13.125 13.959 13.125H10.209C9.86382 13.125 9.58398 12.8452 9.58398 12.5C9.58398 12.1548 9.86382 11.875 10.209 11.875H13.959C14.3042 11.875 14.584 12.1548 14.584 12.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.04102 18.7498C5.69585 18.7498 5.41602 18.47 5.41602 18.1248V17.2915C5.41602 16.9463 5.69585 16.6665 6.04102 16.6665C6.38618 16.6665 6.66602 16.9463 6.66602 17.2915V18.1248C6.66602 18.47 6.38618 18.7498 6.04102 18.7498Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.99935 12.7085C4.99935 13.0537 4.71952 13.3335 4.37435 13.3335H3.54102C3.19584 13.3335 2.91602 13.0537 2.91602 12.7085C2.91602 12.3633 3.19584 12.0835 3.54102 12.0835H4.37435C4.71952 12.0835 4.99935 12.3633 4.99935 12.7085Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.99935 6.875C4.99935 7.22017 4.71952 7.5 4.37435 7.5H3.54102C3.19584 7.5 2.91602 7.22017 2.91602 6.875C2.91602 6.52983 3.19584 6.25 3.54102 6.25H4.37435C4.71952 6.25 4.99935 6.52983 4.99935 6.875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.959 18.7498C13.6138 18.7498 13.334 18.47 13.334 18.1248V17.2915C13.334 16.9463 13.6138 16.6665 13.959 16.6665C14.3042 16.6665 14.584 16.9463 14.584 17.2915V18.1248C14.584 18.47 14.3042 18.7498 13.959 18.7498Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20726_7610"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVault);
export default __webpack_public_path__ + "static/media/vault.c0310788.svg";
export { ForwardRef as ReactComponent };